import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, TextField } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import type { FC } from 'react';

export type SearchInputVariantE = 'outlined' | 'standard';

export interface SearchInputProps {
  disabled?: boolean;
  onClear: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value: string;
  /** 'standard' = underline style (legacy), 'outlined' = rounded borders like other inputs */
  inputVariant?: SearchInputVariantE;
  width?: number | string;
  title?: string;
  id?: string;
  name?: string;
}

/**
 * Search input styled to match the WarrQueue search bar: outlined MUI TextField with a
 * leading search icon and a trailing clear button that appears when there is a value.
 */
export const SearchInput: FC<SearchInputProps> = ({
  disabled = false,
  onClear,
  onChange,
  placeholder = 'Search',
  value,
  inputVariant = 'standard',
  width = 228,
  title,
  id,
  name,
}): JSX.Element => {
  return (
    <TextField
      id={id}
      name={name}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton aria-label="Clear search" size="small" onClick={onClear}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
      onChange={onChange}
      placeholder={placeholder}
      size="small"
      sx={{
        width,
        '& .MuiInputBase-input': { fontSize: '0.95rem' },
        '& .MuiInputBase-input::placeholder': { fontSize: '0.95rem' },
      }}
      title={title}
      value={value}
      variant={inputVariant}
    />
  );
};

export default SearchInput;
